import Icon from './icon';
export default {
  Icon,
  title: 'Key Point',
  hotkey: 'k'
};